import type { Color } from "../types";
import type { ColorStringParser } from "./ColorStringParser";
import type { ColorStringParsersPool } from "./ColorStringParsersPool";

/**
 * Composite color string parser. Trying to parse given color string using parsers from pool unless appropriate
 * parser is found.
 */
export class CompositeColorStringParser implements ColorStringParser {
  /**
   * CompositeColorStringParser constructor.
   *
   * @param parsersPool
   */
  constructor(private readonly parsersPool: ColorStringParsersPool) {}

  /**
   * @inheritDoc
   */
  parse(colorString: string, quantumRange = 255): Color | undefined {
    for (const parser of this.parsersPool.items()) {
      const color = parser.parse(colorString, quantumRange);
      if (color) {
        return color;
      }
    }
  }
}
